<template>
  <div class="page-add">
    <!--操作栏-->
    <div class="add-title">报名审核详情</div>
    <div class="top_rect">
      <div class="name_style">整体报名情况</div>
    </div>
    <!--整体报名情况-->
    <el-table
      :row-style="{ color: '#51627D', fontWeight: 400 }"
      :header-cell-style="{ background: '#DCE7FA', color: '#343C4A', fontWeight: 500 }"
      :data="situationList"
      border
      style="width: 100%">
      <template>
        <el-table-column
          label="工作单位"
          prop="auditDeptName"
          min-width="200%">
        </el-table-column>
        <template v-if="situationList[0] && situationList[0].enrollNumMap">
          <el-table-column v-for="(value, key) in situationList[0].enrollNumMap" :key="key" :label="key" min-width="90%">
            <span>{{ value }}</span>
          </el-table-column>
        </template>
        <el-table-column prop="noJoinNum" label="不参加"></el-table-column>
        <el-table-column
          prop="totalNum"
          label="合计人数">
        </el-table-column>
      </template>
    </el-table>

    <!--轮训班审核学员名单表-->
    <div class="top_rect m-t-24">
      <div class="name_style">学员名单</div>
    </div>
    <el-table
      :row-style="{ color: '#51627D', fontWeight: 400 }"
      :header-cell-style="{ background: '#DCE7FA', color: '#343C4A', fontWeight: 500 }"
      :data="enrollList"
      border
      style="width: 100%">
      <el-table-column
        prop="userName"
        label="学员姓名"
        width="180">
      </el-table-column>
      <el-table-column
        prop="unitPosition"
        label="单位及职务"
        width="500">
      </el-table-column>
      <el-table-column
        prop="periodName"
        label="报名期次">
      </el-table-column>
      <el-table-column
        prop="remarks"
        label="备注"
        width="260">
      </el-table-column>
    </el-table>
    <div class="block">
      <div class="top_rect m-t-24">
        <div class="audit_title">审核详情</div>
      </div>
      <el-timeline v-if="activities.length > 0">
        <el-timeline-item
          v-for="(activity, index) in activities"
          :key="index"
          :icon="activity.icon"
          :type="activity.type"
          :color="activity.color"
          :size="activity.size"
          :timestamp="
            activity.auditDate == null
              ? ''
              : activity.auditDate + '\u3000' + activity.auditContent
          "
        >
          {{ activity.auditUserName }}
        </el-timeline-item>
      </el-timeline>
      <span v-else class="tip_msg">暂无数据</span>
    </div>
    <div class="RCPagination">
      <div style="text-align: center">
        <butn
          title="返回"
          @click="dealBack"
        ></butn>
        <butn
          btntype="primary"
          title="审核"
          v-if="auditStatus == 0"
          @click="showAuditModal"
        ></butn>
      </div>
    </div>
    <!-- 审核详情-->
    <AuditUserModal  @refreshData="resetData"/>
  </div>
</template>
<script>
import vue from "@/main";
import butn from "@/components/button/index";
import {
  getRotationClassAudit,
  getClassEnrollListByDept
} from "@/api/enrollment";
import { auditHistoryList } from "@/api/enrollAudit";
import AuditUserModal from "./auditUserModal.vue"
import { setItem } from "@/utils/storage.js";

export default {
  components: {
    butn,
    AuditUserModal
  },
  data: function() {
    return {
      classId: "",
      auditApplyId: "",
      deptId: "",
      situationList: [],
      enrollList: [],
      activities: [],
      auditStatus: -1,
      auditDetail: {},
    };
  },
  created() {
    //加载详情列表
    this.classId = this.$route.query.classId;
    this.className = this.$route.query.className;
    this.auditApplyId = this.$route.query.auditApplyId;
    this.deptId = this.$route.query.deptId;
    this.auditStatus =  this.$route.query.auditStatus || -1,
    this.getRotationClassAudit();
    this.getClassEnrollListByDept();
    this.getAuditHistoryList(this.auditApplyId)
  },
  methods: {
    // 显示审核弹窗
    showAuditModal() {
      vue.$emit("ShowAuditUser", this.auditDetail, this.className, 0);
    },
    resetData() {
      setItem(this.REFRESH_FLAG, true);
      // this.getAuditHistoryList(this.auditApplyId);
      this.dealBack();
    },
    // 轮训班报名情况详情
    getRotationClassAudit() {
      getRotationClassAudit({ auditApplyId: this.auditApplyId, bizId: this.classId }).then(({ code, data }) => {
        if (code === 0) {
          this.auditDetail = data;
          this.situationList = [data];
        }
      });
    },
    // 轮训班部门学员名单
    getClassEnrollListByDept() {
      getClassEnrollListByDept({ classId: this.classId, deptId: this.deptId }).then(({ code, data }) => {
        if (code === 0) {
          this.enrollList = data || [];
        }
      });
    },
    // 获取审核列表
    getAuditHistoryList(auditApplyId) {
      auditHistoryList(auditApplyId).then(res => {
        if (res.code === 0) {
          let dataArray = res.data;
          if (dataArray != null && dataArray.length > 0) {
            for (let i = 0; i < dataArray.length; i++) {
              if (
                i !== dataArray.length - 1 ||
                (i === dataArray.length - 1 &&
                  dataArray[i].auditSchedule != null)
              ) {
                dataArray[i].icon = "el-icon-success";
                dataArray[i].color = "#3A85FF";
              }
              dataArray[i].size = "large";
            }
            this.activities = dataArray;
          }
        }
      });
    },
    dealBack() {
      this.$router.back();
    },
  }
};
</script>

<style lang="scss" scoped>
  .m-t-24 {
    margin-top: 32px;
  }
  .top_rect {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    padding-top: 12px;
    .name_style {
      font-size: 14px;
      color: #343c4a;
      font-weight: bold;
    }
  }
  .audit_title {
    width: 100%;
    font-size: 14px;
    color: #343c4a;
    padding: 10px 21px 10px 12px;
    background: #f2f3f4;
  }
  .tip_msg {
    color: #909399;
    margin-left: 12px;
  }
</style>
